import { Draft, PayloadAction }      from '@reduxjs/toolkit';
import { IEventParentCategoryState } from 'Redux/Slices/EventParentCategory/EventParentCategorySlice';
import { EventParentCategory }       from 'Domain/Models';
import { removeActionTypes }         from 'Utils/ReducerUtility';

export const updateEventParentCategoryRequest = (state: Draft<IEventParentCategoryState>, { type }: PayloadAction<{ id: string, formData: any }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.lastUpdateId = null;
  state.updatedAt = Date.now();
};

export const updateEventParentCategorySuccess = (state: Draft<IEventParentCategoryState>, { type, payload }: PayloadAction<{
  eventParentCategory: EventParentCategory
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.lastUpdateId = payload.eventParentCategory.id;
  state.entries = { ...state.entries, [payload.eventParentCategory.id]: payload.eventParentCategory };
};

export const updateEventParentCategoryFailure = (state: Draft<IEventParentCategoryState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
